import { clsx } from 'clsx'
import React from 'react'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass' | 'surface'
  padding?: 'none' | 'sm' | 'md' | 'lg'
  children: React.ReactNode
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    { variant = 'default', padding = 'md', className, children, ...props },
    ref
  ) => {
    const baseClasses = ['rounded-lg', 'transition-normal']

    const variantClasses = {
      default: ['bg-surface', 'border', 'hover:bg-surface-hover'],
      glass: [
        'bg-glass',
        'border',
        'backdrop-blur-md',
        'hover:bg-surface-hover',
      ],
      surface: ['bg-surface', 'hover:bg-surface-hover'],
    }

    const paddingClasses = {
      none: [],
      sm: ['p-3'],
      md: ['p-4'],
      lg: ['p-6'],
    }

    const cardClasses = clsx(
      baseClasses,
      variantClasses[variant],
      paddingClasses[padding],
      className
    )

    return (
      <div ref={ref} className={cardClasses} {...props}>
        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'

export default Card
